// extracted by mini-css-extract-plugin
export default {"footer_buttons":"styles_footer_buttons__UeQLd","flex_end":"styles_flex_end__mD1qO","flex_start":"styles_flex_start__UQCF9"};